import _ from "@lodash";
import { AppBar, Badge, DialogContent, IconButton, Tab, Tabs, Toolbar, Typography } from "@material-ui/core";
import "@webex/widgets/dist/css/webex-widgets.css";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import React from "react";
import { MdClose } from "react-icons/md";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/WebexActions";
import reducer from "./Store/Reducers/WebexReducer";

const WebexMeetingsWidget = React.lazy(() =>
   import("@webex/widgets").then(module => {
      return { default: module.WebexMeetingsWidget };
   })
);

const NewState = {
   idpessoaformulario: null,
   title: "",
   agendado: null,
   aguardandoToken: false,
   tabValue: 0,
};

class WebexMeeting extends XAPPComponent {

   state = { ...NewState };

   componentDidMount() {
      const { xappRouteParams, getToken, sistemas = null } = this.props;
      if (!_.isNull(sistemas) && !_.isNull(sistemas[xappRouteParams.empresa])) {
         this.setState(_.set({ ...this.state }, "idpessoaformulario", sistemas[xappRouteParams.empresa].idpessoaformulario));
         getToken(sistemas[xappRouteParams.empresa].idpessoaformulario, xappRouteParams);
      }
   }

   componentDidUpdate(prevProps) {
      const { meetingDetails = null, integracao = null, getParticipants, open } = this.props;
      const form = this.state;
      if (open && !_.isNull(integracao) && !_.isEqual(integracao, prevProps.integracao) && form.tabValue === 0) {
         getParticipants(integracao, meetingDetails.id);
      }

      if (open && !_.isNull(integracao) && !_.isUndefined(integracao.access_token) && form.tabValue === 0) {
         setTimeout(() => {
            getParticipants(integracao, meetingDetails.id);
         }, 30000);
      }
   }

   handleChangeTab = (ev, index) => {
      this.setState(_.set({ ...this.state }, "tabValue", index));
   };

   render() {
      const { open, meetingDetails = null, integracao = null, participantes, toogleMeeting, updateParticipants, xappRouteParams, autorizar, Reducer, getToken } = this.props;
      const form = this.state;
      let participantesLobby = [];
      if (!_.isUndefined(participantes) && !_.isNull(participantes)) {
         participantesLobby = participantes.filter(x => x.state === "lobby");
      }
      return (
         <React.Fragment>
            {!_.isNull(meetingDetails) &&
               <React.Fragment>
                  {open && !_.isNull(integracao) && !_.isUndefined(integracao.access_token) &&
                     <React.Fragment>
                        <AppBar position="static" elevation={1} className="xs:hidden">
                           <Toolbar className="flex w-full min-h-0 h-32">
                              <Typography variant="subtitle1 text-white">{"Acessar videochamada"}</Typography>
                              <div className="flex-1" />
                              <IconButton key="close" aria-label="Close" className="p-6" onClick={() => toogleMeeting()}>
                                 <MdClose className="text-20 text-white" />
                              </IconButton>
                           </Toolbar>
                        </AppBar>
                        <Tabs
                           value={form.tabValue}
                           onChange={this.handleChangeTab}
                           indicatorColor="secondary"
                           textColor="secondary"
                           variant="fullWidth"
                           scrollButtons="auto"
                           classes={{ root: "h-32 w-full bg-white" }}
                        >
                           <Tab value={0} classes={{ root: "h-32" }} label={<Badge badgeContent={participantesLobby.length} color="error" > {"Lobby"}</Badge>} />
                           <Tab value={1} classes={{ root: "h-32" }} label="Sala" />
                        </Tabs>
                        {form.tabValue === 0 &&
                           <div className="flex flex-col xs:w-full w-400">
                              {participantesLobby.length > 0 ? participantesLobby.map((item) => (
                                 <div key={item.id} id={item.id} className="flex flex-row w-full bg-white justify-between px-12 py-6 border-b-1 border-grey"                                                                    >
                                    <div>
                                       <Typography>{item.displayName}</Typography>
                                       <Typography>{item.email}</Typography>
                                    </div>
                                    <div>
                                       <XAPPButton
                                          type="icon"
                                          className="mr-8 text-red"
                                          variant="contained"
                                          onClick={() => updateParticipants(integracao, item.id, false)}
                                          iconProps={"justify-center"}
                                          icon={"close"}
                                          label={""}
                                       />
                                       <XAPPButton
                                          type="icon"
                                          className="mr-8 text-green"
                                          variant="contained"
                                          onClick={() => updateParticipants(integracao, item.id, true)}
                                          iconProps={"justify-center"}
                                          icon={"done"}
                                          label={""}
                                       />
                                    </div>
                                 </div>
                              ))
                                 :
                                 <div className="flex flex-col flex-1 items-center justify-center text-center p-16">
                                    <Typography variant="h6" color="textSecondary" className="mb-16">
                                       {"Ninguém esperando no lobby."}
                                    </Typography>
                                 </div>
                              }
                           </div>
                        }
                        <div className={form.tabValue === 1 ? "block" : "hidden"}>
                           <React.Suspense fallback={<div></div>}>
                              <WebexMeetingsWidget
                                 className="xs:w-full w-400 xs:h-256 h-400"
                                 accessToken={integracao.access_token}
                                 meetingDestination={meetingDetails.sipAddress}
                              />
                           </React.Suspense>
                        </div>
                     </React.Fragment>
                  }
                  <XAPPDialog
                     id="WebexMeeting"
                     open={open && (_.isNull(integracao) || _.isUndefined(integracao.access_token))}
                     fullWidth
                     maxWidth="sm"
                     onClose={() => toogleMeeting()}
                  >
                     <AppBar position="static" elevation={1}>
                        <Toolbar className="flex w-full min-h-0 h-32">
                           <Typography variant="subtitle1 text-white">{"Acessar videochamada"}</Typography>
                           <div className="flex-1" />
                           <IconButton key="close" aria-label="Close" className="p-6" onClick={() => toogleMeeting()}>
                              <MdClose className="text-20 text-white" />
                           </IconButton>
                        </Toolbar>
                     </AppBar>
                     <DialogContent classes={{ root: "p-16" }}>
                        {(_.isNull(integracao) || _.isUndefined(integracao.access_token)) && !form.aguardandoToken &&
                           <div className="flex w-full flex-col justify-center items-center">
                              <Typography color="textSecondary" className="mb-4">
                                 {"Não identificamos a autorização para acessar webex"}
                              </Typography>
                              <XAPPButton
                                 type="Button"
                                 className=""
                                 variant="contained"
                                 color="primary"
                                 iconProps="mr-8"
                                 icon={"done"}
                                 label={"autorizar"}
                                 onClick={() => {
                                    this.setState(_.set({ ...this.state }, "aguardandoToken", true));
                                    autorizar(form.idpessoaformulario, xappRouteParams, 0, Reducer.chave);
                                 }}
                              />
                           </div>
                        }
                        {form.aguardandoToken &&
                           <div className="flex w-full flex-col justify-center items-center">
                              <Typography color="textSecondary" className="mb-4">
                                 {"Tudo pronto com a autorização webex?"}
                              </Typography>
                              <XAPPButton
                                 type="Button"
                                 className="bg-green hover:bg-green"
                                 variant="contained"
                                 color="primary"
                                 iconProps="mr-8"
                                 icon={"done"}
                                 label={"tudo pronto"}
                                 onClick={() => {
                                    this.setState(_.set({ ...this.state }, "aguardandoToken", false));
                                    getToken(form.idpessoaformulario, xappRouteParams);
                                 }}
                              />
                           </div>
                        }
                     </DialogContent>
                  </XAPPDialog>
               </React.Fragment>
            }
         </React.Fragment>
      );
   }
}

function mapDispatchToProps(dispatch) {
   return bindActionCreators({
      showMessage: AppActions.showMessage,
      getToken: Actions.getToken,
      getParticipants: Actions.getParticipants,
      updateParticipants: Actions.updateParticipants,
      autorizar: Actions.autorizar,
      clearReducer: Actions.clearReducer,
      toogleMeeting: Actions.toogleMeeting,
   }, dispatch);
}

function mapStateToProps({ Webex, auth }) {
   return {
      integracao: Webex.integracao,
      open: Webex.open,
      participantes: Webex.participantes,
      sistemas: auth.user.data.settings.sistemas,
   };
}

export default withReducer("Webex", reducer)(withRouter(connect(mapStateToProps, mapDispatchToProps)(WebexMeeting)));
